export default __webpack_public_path__ + "static/media/token_right_tablet.36806955.png";